import React from 'react';
import { useFormGeneratorField } from '../hooks/useFormGeneratorField';
import UniFormcompoErrorInField from './UniFormcompoErrorInField';

const UniFormgenInputPassword = (props) => {
  const {
    warningtip,
    valueToDisplay,
  } = useFormGeneratorField(props);

  let params = {};
  if (props.params) {
    params = props.params;
  }
  let readonly = false;
  if (params.readonly === true) {
    readonly = true;
  }
  let name = 'unnamed';
  if (typeof params.name === 'string' && params.name !== '') {
    name = params.name;
  }
  let formState = {};
  if (props.formState) {
    formState = props.formState;
  }
  let formErrors = {};
  if (props.formErrors) {
    formErrors = props.formErrors;
  }
  let handleChange = null;
  if (typeof props.handleChange === 'function') {
    handleChange = props.handleChange;
  }

  let extraClass = '';
  if (typeof params.extraclass === 'string' && params.extraclass !== '') {
    extraClass = ' ' + params.extraclass;
  }

  let cl = 'uniformcompo__field' + extraClass;
  if (typeof formErrors[name] === 'string' && formErrors[name] !== '') {
    cl += ' error';
  }

  let style = {};
  if (params.w > 0) {
    style.width = params.w;
  }

  let tooltip = null;
  if (typeof params.tooltip === 'string' && params.tooltip !== '') {
    tooltip = params.tooltip;
  }

  const infotip = 'name: ' + name + ' (text)';

  return (
    <div className={cl} style={style}>
      <label htmlFor={name}>
        {
          tooltip ? (<abbr title={tooltip}>{params.label}</abbr>) : (params.label)
        }
      </label>
      <UniFormcompoErrorInField error={formErrors[name]} />
      <div className="uniformcompo__field__infotip-container"><div className="uniformcompo__field__infotip">{infotip}</div></div>
      {
        warningtip ? (
          <div className="uniformcompo__field__warningtip-container"><div className={"uniformcompo__field__warningtip" + (" frfr-js-tinytag frfr-js-tinytag--primitive-value-type--" + warningtip)}>{warningtip}</div></div>
        ) : null
      }
      <input
        type="password"
        name={name}
        readOnly={readonly}
        value={formState[name]}
        onChange={handleChange}
      />
    </div>
  );
};

export default UniFormgenInputPassword;